import { useCallback } from "react";
import API from "../API/newIndex";
import { useUser } from "../controllers/UserContext";

/**
 * Custom hook to intercept and synchronize table column/sort changes
 * directly with UserContext (tableData / sortData).
 */
const useTableApi = () => {
  const { setUserInfo } = useUser();

  const handleTableApi = useCallback(
    async (config) => {
      if (
        config?.url?.includes("/admin/user/UpdateTablesData") ||
        config?.url === "/admin/user/UpdateTablesData"
      ) {
        if (config?.data?.tables || config?.data?.sort_data) {
          setUserInfo((prev) => {
            const currentTables = prev?.tables || {};
            const nextTables = config?.data?.tables
              ? { ...currentTables, ...config.data.tables }
              : { ...currentTables };

            if (config?.data?.sort_data) {
              nextTables.sort_data = {
                ...(currentTables.sort_data || {}),
                ...config.data.sort_data,
              };
            }

            return {
              ...(prev || {}),
              tables: nextTables,
            };
          });
        }
      }
      return API(config);
    },
    [setUserInfo]
  );

  return handleTableApi;
};

export default useTableApi;
